
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-open-ai-demo-open-ai-chat-provider","docs-x-sdk-chat-provider-open-ai-demo-openai"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.en-US.md?type=demo')
};